import { getCurrentUser } from 'aws-amplify/auth';
import SentryWrap from 'components/Sentry';
import StandardsDashboardView from 'components/AdminBooks/StandardsDashboardView';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { handleListAllBooks } from 'store/books/thunks';
import { handleListStoryStandard } from 'store/story/thunks';

const Wrapper = styled.div`
  height: 100%;
  padding: 20px 0;
  width: 100%;
`;

const StandardsDashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        await getCurrentUser();
        // await dispatch(handleListAllBooks());
        // await dispatch(handleListStoryStandard());
        setLoading(false);
      } catch {
        navigate('/');
      }
    };
    load();
  }, [dispatch, navigate]);

  return (
    <SentryWrap>
      <Wrapper className="adminForm">
        <StandardsDashboardView userloading={loading} />
      </Wrapper>
    </SentryWrap>
  );
};

export default StandardsDashboard;
